import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";

import s1 from "../assets/image19.jpeg";
import s2 from "../assets/image6.jpeg";
import s3 from "../assets/image7.jpeg";
import s4 from "../assets/image16.jpeg";
import s5 from "../assets/image40.jpeg";
import s6 from "../assets/image18.jpeg";
import s7 from "../assets/image11.jpeg";
import s8 from "../assets/banner9.png";

export default function View({ uuid }) {

  const appContext = useContext(AppContext);

  const staticGalleryData = [
      {
      uuid: "gal-001",
      title: "Mkutano Mkuu wa Mwaka wa Wanachama",
      coverPhoto: s1,
      category: "Mikutano",
      dateCreated: "2024",
    },
    {
      uuid: "gal-002",
      title: "Baadhi ya wanachama ambao ni mume na mke (couple) ndani ya YCSC SACCOS. Tabasamu la mtu na mweza wake. Ikumbukwe kuwa kila mwanachama ana haki sawa ndani ya chama.",
      coverPhoto: s2,
      category: "Teknolojia",
      dateCreated: "2024",
    },
    {
      uuid: "gal-003",
      title: "Eneo la Mkutano mkuu wa YCSC SACCOS LIMITED 2022 ilikua ni EPLAS",
      coverPhoto: s3,
      category: "Mafunzo",
      dateCreated: "2022",
    },
    {
      uuid: "gal-004",
      title: "Mwenyekiti wa Bodi akitoa maelezo au ripoti fupi siku ya sherehe za mwisho wa mwaka 2024",
      coverPhoto: s4,
      category: "Uongozi",
      dateCreated: "2024",
    },
    {
      uuid: "gal-005",
      title: "Utoaji wa Tuzo kwa Wawekaji Akiba Bora",
      coverPhoto: s5,
      category: "Matukio",
      dateCreated: "2025",
    },
    {
      uuid: "gal-006",
      title: "Wadada wa YCSCS SACCOS wakiendelea kujipatia kifungua kinywa sherehe ya mwisho wa mwaka 2024",
      coverPhoto: s6,
      category: "Matukio",
      dateCreated: "2024",
    },
    {
      uuid: "gal-007",
      title: "Sherehe za Maadhimisho ya Miaka ya Ukuaji",
      coverPhoto: s7,
      category: "Matukio",
      dateCreated: "2024",
    },
    {
      uuid: "gal-008",
      title: "Picha ya pamoja 2024 ",
      coverPhoto: s8,
      category: "Ukuaji",
      dateCreated: "2024",
    },
    ];

  /* Place states here */
  const [ ready, setReady ] = useState(false);
  const [ data, setData ] = useState(null);

  async function init() {
    setReady(false);
    
    /* ==================================================================
    DYNAMIC PARTS (COMMENTED OUT FOR FUTURE API INTEGRATION)
    ==================================================================
    await Promise.all([
      getData(),
    ])
    ==================================================================
    */

    // Kazi ya static: Tafuta data moja kwa moja kwa kutumia uuid kutoka kwenye props
    const localItem = staticGalleryData.find(item => item.uuid === uuid);
    if (localItem) {
      setData(localItem);
    } else {
      // Kama haikupatikana, chukua ya kwanza kama default ili kuzuia error
      setData(staticGalleryData[0]);
    }
    
    setReady(true);
  }

  async function getData() {
    await callApi('get-gallery-data', { uuid }).then((response) => {
      if(response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    })
  }

  useEffect(() => {
    init();
  }, []);

  

  if (ready && data) {
    return (
      
      <div 
        className="container"
        
      >
        
    

        <div className="row">

          <div className="col-md-12">
            <h6
              className="main-section-title font-semi-bold"
            >
              {data.title}
            </h6>
          </div>

          
          <div className="col-md-12 mt-2 mb-2">
            <img
              src={data.coverPhoto}
              style={{
                width: "100%"
              }}
            />
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <h6
              style={{
                fontSize: "12px"
              }}
              className="text-end text-muted font-semi-bold"
            >
              {data.dateCreated}
            </h6>
            <hr/>
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <h6
              style={{
                fontSize: "16px"
              }}
              className=""
            >
              {data.category}
            </h6>
          </div>
          
          
        </div>

        
      </div>
       
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
